import "./App.css";
import Todo from "./components/Todo";

function App() {
  return (
    <div className="App">
      <Todo />
    </div>
  );
}

export default App;
